<template>
  <div>
    <!-- banner -->
    <div class="carousel_wrap">
      <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 公司简介 -->
    <div class="introduce">
      <h1>公司简介</h1>
      <div>
        <img :src="intors.img" loading="lazy" />
        <ul>
          <li v-for="(item, index) in intors.content" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <!-- 我们能做什么 -->
    <div class="candos">
      <div class="candos-container">
        <h2>我们能做什么</h2>
        <h3>为您提供可靠的排队解决方案及优质的售后服务</h3>
        <ul>
          <li v-for="(item, index) in candos" :key="index">
            <img :src="item.img" loading="lazy" />
            <h4>{{ item.title }}</h4>
            <div>{{ item.content }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: [],
      candos: [],
      intors: {
        img: "",
        content: []
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH

      fetch(baseUrl + '/aboutus/data.json')
        .then(response => response.json())
        .then(data => {
          let { banners, intors, candos } = data
          this.bannerList = banners
          this.intors.img = intors.img
          this.intors.content = intors.content
          this.candos = candos
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
   @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}

.introduce {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;

  > div {
    display: flex;
    margin-top: 20px;
   @media screen and (max-width: 1024px) {
      flex-direction: column;
      align-items: center;
      width: 95%;
   
    }

    img {
      // width: 38%;
      height: 300px;
      max-height: 300px;
      max-width: 300px;
    }
    > ul {
      margin-left: 70px;
      display: flex;
      flex-direction: column;
      font-size: 20px;
      line-height: 2em;
     @media screen and (max-width: 768px) {
        margin-left: 0px;
      }
      > li {
        margin-bottom: 10px;
      }
    }
  }
}
.candos {
  width: 100%;
  background: url("../../assets/img/14.dfc68f4.png") 0 0 no-repeat;
  background-size: cover;
}
.candos-container {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    margin-top: 105px;
    margin-bottom: 15px;
  }
  h3 {
    margin-bottom: 50px;
  }
  > ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    li {
      list-style: none;
      border: 1px solid gray;

      width: 320px;
      height: 300px;
      margin-bottom: 20px;
      margin-right: 38px;

      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      @media screen and (max-width: 1024px) {
        width: 300px;
        height: 300px;
        margin-bottom: 20px;
        margin-right: 38px;
      }
      > img {
        width: 100px;
        height: 100px;
      }
      > h4 {
        margin-top: 10px;
        margin-bottom: 10px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        line-height: 48px;
      }
      > div {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        padding: 0 30px;
        line-height: 2em;
        text-align: center;
      }
    }
  }
}
</style>